import React from 'react';
import { DomainCardButton } from '../../domain-cards/ui';

/**
 * PassiveInfoPattern - Pattern for display-only information (lore, divinities)
 *
 * Config properties used:
 * - displayName: section title
 * - description: main description
 * - divinities: array of divinity definitions (for Faint Divinity)
 * - note: additional note text
 */
const PassiveInfoPattern = ({
  config,
  onClose,
}) => {
  const divinities = config.divinities || [];

  return (
    <div className="space-y-4">
      {/* Header */}
      <div className="text-center">
        <h3 className="text-xl font-bold text-purple-600 dark:text-purple-400 mb-1">
          ✨ {config.displayName || 'Information'}
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          {config.description}
        </p>
      </div>

      {/* Divinities List */}
      {divinities.length > 0 && (
        <div className="space-y-2 max-h-64 overflow-y-auto">
          {divinities.map((divinity) => (
            <div
              key={divinity.id}
              className="bg-purple-900/20 p-3 rounded-lg border border-purple-700"
            >
              <p className="font-medium text-purple-300">{divinity.name}</p>
              <p className="text-xs text-gray-400 mt-1">
                <span className="text-purple-400">Tribute:</span> {divinity.tribute}
              </p>
              {divinity.domain && (
                <p className="text-xs text-gray-500">
                  Domain: {divinity.domain}
                </p>
              )}
            </div>
          ))}
        </div>
      )}

      {/* Note */}
      {config.note && (
        <div className="bg-gray-800 p-3 rounded-lg border border-gray-600">
          <p className="text-sm text-gray-400 italic">{config.note}</p>
        </div>
      )}

      <DomainCardButton onClick={onClose} variant="secondary" className="w-full">
        Close
      </DomainCardButton>
    </div>
  );
};

export default PassiveInfoPattern;
